import React from 'react';
import { Row, Col, Skeleton, Space } from 'antd';
import moment from 'moment';

import { Texto } from '../Texto';
import * as S from '../styles';

export function Motorista({ data, loading = false }) {
  return (
    <Col span={24} style={{ marginTop: loading ? 12 : 0 }}>
      <Skeleton
        active
        size="small"
        loading={loading}
        paragraph={{ width: '100%' }}
        block={true}
      >
        {data?.pessoaFisicaCadastro?.cpf && (
          <MotoristaPessoaFisica motorista={data} />
        )}
        {data?.pessoaFisicaCadastro?.cnpj && (
          <MotoristaPessoaJuridica motorista={data} />
        )}
        {!data?.pessoaFisicaCadastro?.cnpj && !data?.pessoaFisicaCadastro?.cpf && (
          <Row justify="center">
            <Space
              style={{
                margin: '60px 0',
                padding: '12px 24px',
                borderRadius: 8,
                border: 'none',
                backgroundColor: '#F1F4F5',
              }}
            >
              <h1 style={{ color: '#0D3549' }}>Dados não encontrados.</h1>
            </Space>
          </Row>
        )}
      </Skeleton>
    </Col>
  );
}

function MotoristaPessoaFisica({ motorista }) {
  return (
    <Col span={24} style={{ margin: '24px 0' }}>
      <Row justify="center" style={{ marginBottom: '8px' }}>
        <Col span={24}>
          <S.TituloDetalheVeiculo>{'Dados do Motorista '}</S.TituloDetalheVeiculo>
        </Col>
      </Row>
      <Row
        gutter={[2, 8]}
        style={{ marginBottom: '16px' }}
        justify="space-between"
      >
        <Col span={4}>
          <Texto
            titulo="Nome"
            valor={motorista?.pessoaFisicaCadastro?.nome || '-'}
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="CPF"
            valor={motorista?.pessoaFisicaCadastro?.cpfFormatado || '-'}
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="Categoria"
            valor={
              motorista?.pessoaFisicaCadastro?.motoristaCadastro
                ?.categoriaCNH || '-'
            }
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="UF CNH"
            valor={
              motorista?.pessoaFisicaCadastro?.motoristaCadastro
                ?.ufEmissaoCNH || '-'
            }
          />
        </Col>
        <Col className="gutter-row" span={4}>
          <Texto
            titulo="Nascimento"
            valor={
              (motorista?.pessoaFisicaCadastro?.dataNascimento &&
                moment(motorista?.pessoaFisicaCadastro?.dataNascimento).format(
                  'DD/MM/YYYY'
                )) ||
              '-'
            }
          />
        </Col>
      </Row>
      <Row
        gutter={[2, 8]}
        style={{ marginBottom: '16px' }}
        justify="space-between"
      >
        <Col className="gutter-row" span={4}>
          <Texto titulo="Telefone" valor={motorista?.telefone || '-'} />
        </Col>
        <Col className="gutter-row" span={4}>
          <Texto
            titulo="Nome da Mãe"
            valor={motorista?.pessoaFisicaCadastro?.nomeMae || '-'}
          />
        </Col>
        <Col className="gutter-row" span={4}>
          <Texto
            titulo="Nome do Pai"
            valor={motorista?.pessoaFisicaCadastro?.nomePai || '-'}
          />
        </Col>
        <Col className="gutter-row" span={4}>
          <Texto
            titulo="Naturalidade"
            valor={motorista?.pessoaFisicaCadastro?.naturalidade || '-'}
          />
        </Col>
        <Col className="gutter-row" span={4}>
          <Texto
            titulo="RG"
            valor={motorista?.pessoaFisicaCadastro?.numeroRG || '-'}
          />
        </Col>
      </Row>
      <Row
        gutter={[2, 8]}
        style={{ marginBottom: '16px' }}
        justify="space-between"
      >
        <Col className="gutter-row" span={4}>
          <Texto
            titulo="Formulário da CNH"
            valor={
              motorista?.pessoaFisicaCadastro?.motoristaCadastro
                ?.numeroFormularioCNH || '-'
            }
          />
        </Col>
        <Col className="gutter-row" span={4}>
          <Texto
            titulo="Número de registro CNH"
            valor={
              motorista?.pessoaFisicaCadastro?.motoristaCadastro
                ?.numeroRegistroCNH || '-'
            }
          />
        </Col>
        <Col className="gutter-row" span={4}>
          <Texto
            titulo="Data de Emissão CNH"
            valor={
              (motorista?.pessoaFisicaCadastro?.motoristaCadastro
                ?.dataEmissaoCNH &&
                moment(
                  motorista?.pessoaFisicaCadastro?.motoristaCadastro
                    ?.dataEmissaoCNH
                ).format('DD/MM/YYYY')) ||
              '-'
            }
          />
        </Col>
        <Col className="gutter-row" span={4}>
          <Texto
            titulo="Validade CNH"
            valor={
              (motorista?.pessoaFisicaCadastro?.motoristaCadastro
                ?.dataValidadeCNH &&
                moment(
                  motorista?.pessoaFisicaCadastro?.motoristaCadastro
                    ?.dataValidadeCNH
                ).format('DD/MM/YYYY')) ||
              '-'
            }
          />
        </Col>
        <Col className="gutter-row" span={4}>
          <Texto
            titulo="Código de segurança CN"
            valor={
              motorista?.pessoaFisicaCadastro?.motoristaCadastro
                ?.codigoSegurancaCNH || '-'
            }
          />
        </Col>
      </Row>
      <Row
        gutter={[2, 8]}
        style={{ marginBottom: '16px' }}
        justify="space-between"
      >
        <Col className="gutter-row" span={4}>
          <Texto
            titulo="UF RG"
            valor={motorista?.pessoaFisicaCadastro?.ufrg || '-'}
          />
        </Col>
        <Col className="gutter-row" pull={15} span={4}>
          <Texto titulo="Endereco" valor={motorista?.endereco || '-'} />
        </Col>
      </Row>
    </Col>
  );
}

function MotoristaPessoaJuridica({ motorista }) {
  return (
    <Col span={24} style={{ margin: '24px 0' }}>
      <Row justify="center" style={{ marginBottom: '8px' }}>
        <Col span={24}>
          <S.TituloDetalheVeiculo>{'Dados do Motorista '}</S.TituloDetalheVeiculo>
        </Col>
      </Row>
      <Row
        gutter={[2, 8]}
        style={{ marginBottom: '16px' }}
        justify="space-between"
      >
        <Col className="gutter-row" span={4}>
          <Texto
            titulo="Nome Fantasia"
            valor={motorista?.pessoaJuridicaCadastro?.nomeFantasia || '-'}
          />
        </Col>
        <Col className="gutter-row" span={4}>
          <Texto
            titulo="Razão Social"
            valor={motorista?.pessoaJuridicaCadastro?.razaoSocial || '-'}
          />
        </Col>
        <Col className="gutter-row" span={4}>
          <Texto
            titulo="CNPJ"
            valor={motorista?.pessoaJuridicaCadastro?.cnpjFormatado || '-'}
          />
        </Col>
        <Col className="gutter-row" span={4}>
          <Texto
            titulo="Inscricao Estadual"
            valor={motorista?.pessoaJuridicaCadastro?.inscricaoEstadual || '-'}
          />
        </Col>
        <Col className="gutter-row" span={4}>
          <Texto titulo="Fone 1" valor={motorista?.telefone || '-'} />
        </Col>
      </Row>
    </Col>
  );
}
